<template>
  <div @click="setBoardActiveLine(title)">
    <v-row align="center" no-gutters>
      <v-col cols="9">
        <v-icon v-if="title === boardActiveLine" color="grey lighten-1" left>
          mdi-chevron-up
        </v-icon>
        <v-icon v-else color="grey lighten-1" left> mdi-chevron-down </v-icon>
        {{ $t(`status.${title}`) }}
        <v-tooltip v-if="information" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="grey lighten-1" small right>
              mdi-information-outline
            </v-icon>
          </template>
          <div class="mw-200 caption text-left">
            {{ information }}
          </div>
        </v-tooltip>
      </v-col>
      <v-col cols="3" class="text-right">
        <v-chip color="mr-3 grey lighten-2" small>
          <span class="grey--text text--darken-2 font-weight-bold">
            {{ total }}
          </span>
        </v-chip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'BoardListTitle',

  props: {
    title: {
      type: String,
      required: true,
    },

    total: {
      type: String | Number,
    },

    information: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters(['boardActiveLine']),
  },

  methods: {
    ...mapMutations(['setBoardActiveLine']),
  },
}
</script>
